import { createAsyncThunk } from '@reduxjs/toolkit'

import { AppDispatch, RootState } from '../reducers'
import currentPlaySlice from '../reducers/currentPlaySlice'
import {
  selectCurrentTrackMeta,
  selectCurrentTrackSlug,
  selectIsScoreDirty,
} from '../selectors/current-play-selectors'
import { selectMode } from '../selectors/session-selectors'
import Gamer from '../services/Gamer'
import { saveLocalTiming } from './authoring/local-storage-actions'
import timingChanged from './authoring/timingChanged'

const Download = require('downloadjs')

const doSave = createAsyncThunk<
  void,
  { isDownload?: boolean; gamer: Gamer },
  { state: RootState; dispatch: AppDispatch }
>('save', ({ isDownload, gamer }, { dispatch, getState }) => {
  const state = getState()
  const trackSlug = selectCurrentTrackSlug(state)
  const mode = selectMode(state)
  const isScoreDirty = selectIsScoreDirty(state)
  const currentLRC = gamer.currentLRC
  const exportLRC = () => {
    const meta = selectCurrentTrackMeta(state)
    Download(meta.concat(currentLRC), `${trackSlug}.lrc`, 'text/plain')
    const currentLyrics = gamer.currentLyricsText
    Download(meta.concat(currentLyrics), `${trackSlug}.txt`, 'text/plain')
  }
  const exportCSV = () => {
    const meta = selectCurrentTrackMeta(state)
    const currentCSV = gamer.currentCSV
    Download(meta.concat(currentCSV), `${trackSlug}.csv`, 'text/plain')
  }
  switch (mode) {
    case 'edit':
      if (isDownload) {
        const isShiftKey = false // TODO
        if (isShiftKey) {
          exportCSV()
        } else {
          exportLRC()
        }
      } else if (isScoreDirty) {
        dispatch(timingChanged(gamer))
      }
      break
    case 'play':
      if (isDownload) {
        exportLRC()
      } else {
        const scoreSeconds = gamer.scoreSeconds
        dispatch(saveLocalTiming({ trackSlug, timing: currentLRC, scoreSeconds }))
        dispatch(currentPlaySlice.actions.setIsScoreDirty(false))
      }
      break
    case 'viz':
      // TODO:
      break
    default:
  }
})

export const removeLocalSong = (songInfo: any) => {
  console.log('not yet implemented') // TODO:
}

// desktop only
export const saveLocal = () => {
  // if (!this.isCurrPlaylistLocal) {
  //   return; // HACK until we support saving non-local
  // }
  // const songSlug = this.currentSongSlug; // TODO: might be empty if no song picked. FIX: disallow, or get from lyrics?
  // const lrcText = this.currentLRC;
  // this.playlistModel.updateReference(songSlug,lrcText);
}

export default doSave
